document.addEventListener('DOMContentLoaded', () => {
    const epiForms = document.querySelectorAll('.form-block .EPiServerForms');

    epiForms.forEach(form => {
        const observer = new MutationObserver(mutationsList => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Check if the form has a success message after submission
                    const successStatusElement = form.querySelector('.Form__Status__Message.Form__Success__Message');
                    if (successStatusElement) {
                        // Get form section's top and scroll to it.
                        const sectionEl = successStatusElement.closest('section');
                        const elementTop = sectionEl ? (sectionEl.getBoundingClientRect().top + window.pageYOffset) : (form.getBoundingClientRect().top + window.pageYOffset) - 172;

                        window.scrollTo({
                            top: elementTop,
                            behavior: 'smooth',
                        });
                    }
                }
            }
        });

        // Start tracking changes inside the form element
        observer.observe(form, { childList: true, subtree: true });
    });
});
